
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ar/gallery",
      function () {
        return require("private-next-pages/ar/gallery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ar/gallery"])
      });
    }
  